module.exports = __webpack_public_path__ + "static/img/dzp8.edcfb40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dzp8.jpg
// module id = cX9T
// module chunks = 1